/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import moment from 'moment'
import autoBind from 'react-autobind'
import { injectIntl } from 'react-intl'
import { RaisedButton } from 'material-ui'

import AlertModal from 'generic/dialog/AlertModal'
import LoadingDialog from 'generic/dialog/LoadingDialog'

import BaseValidation from 'components/common/BaseValidation'

import { messages } from 'constants/messages'
import * as actions from 'actions/Proposal'

class PrestationProposal extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)
   
    this.state = {
      open: false,
      loading: true,
      errors: {
        errorMessage: undefined,
        errorFields: {}
      },
      message: undefined,
      send: false,
      isTokenAccepted: false
    }
  }

  componentDidMount() {
    actions.getPrestationProposalAction(this.props.match.params.token)
      .then((result) => {
        const obj = result.data.object
        const isTokenAccepted = obj.accepted_token === this.props.match.params.token
        this.setState({
          open: true,
          isTokenAccepted: isTokenAccepted,
          message: isTokenAccepted
            ? this.props.intl.formatMessage(messages.PROPOSAL_ACCEPT_MESSAGE, {
              id: obj.prestation_number,
              date: moment(obj.start_time).format('DD.MM.YYYY'), 
              start: moment(obj.start_time).format('HH:mm'),
              end: moment(obj.end_time).format('HH:mm'),
              prestationType: obj.prestation_type_value,
              displayDate: !obj.prestation_type_value,
              displayTime: !obj.prestation_type_value
            })
            : this.props.intl.formatMessage(messages.PROPOSAL_REFUSE_MESSAGE)
        })
      })
      .catch((error) => {
        if (error && error.status === 404) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.data.errors[0].user_message,
            },
          })
        }
      })
      .finally(() => {
        this.setState({
          loading: false
        })
      })
  }

  handleConfirm() {
    this.setState({
      loading: true
    })

    actions.postPrestationProposalAction(this.props.match.params.token)
      .then((result) => {
        this.setState({
          send: true,
        })
      })    
      .catch((error) => {
        if (error && error.status === 404) {
          this.setState({
            errors: {
              ...this.state.errors,
              errorMessage: error.data.errors[0].user_message,
            },
          })
        }
      })
      .finally(() => {
        this.setState({
          open: false,
          loading: false
        })
      })
  }

  handleLogin() {
    this.props.history.push({pathname: '/login/'})
  }

  render () {
    return (
      <BaseValidation>
        {
          this.state.loading
            ? <LoadingDialog/>
            : <React.Fragment>
              {
                this.state.errors.errorMessage
                  ? <div
                    style={{...styles.message,...{color: 'red'}}}
                  >
                    { this.state.errors.errorMessage }
                  </div>
                  : <React.Fragment>
                    {
                      this.state.send
                        ? <div style={styles.message}>
                          <div className='row'>
                            {
                              this.state.isTokenAccepted
                                ? this.props.intl.formatMessage(messages.PRESTATION_PROPOSAL_ACCEPTED_SEND)
                                : this.props.intl.formatMessage(messages.PRESTATION_PROPOSAL_REFUSED_SEND)
                            }
                          </div>
                          <RaisedButton
                            label={this.props.intl.formatMessage(messages.BACK_TO_LOGIN)}
                            primary={true}
                            style={{marginTop: 5}}
                            onClick={this.handleLogin}
                          />
                        </div>
                        : <AlertModal
                          modal={true}
                          open={this.state.open}
                          title={this.props.intl.formatMessage(messages.PROPOSAL_TITLE)}
                          type={AlertModal.CONFIRM}
                          handleConfirm={this.handleConfirm}
                        >
                          <div style={{textAlign: 'center'}}>
                            {this.state.message}
                          </div>
                        </AlertModal>
                    }
                  </React.Fragment>
              }
            </React.Fragment>
        }
      </BaseValidation>
    )
  }
}

const styles = {
  message: {
    color: '#5d5d5d',
    fontWeight: 300,
    fontSize: '1.25rem',
    textAlign: 'center'
  }
}

export default injectIntl(PrestationProposal)



// WEBPACK FOOTER //
// ./src/components/applicant/PrestationProposal.js